import UserAppBar from './UserAppBar'
import TemplateListTypes from '../TemplateListTypes'
// import { useState } from 'react'
// import TemplateEditor from './TemplateEditor'
// import { ITemplate } from '../../../types/templates'

/**
 * Custom `TemplateSelector` component declaration.
 * Load UserAppBar and TemplateListTypes with message welcome
 * @return TemplateSelector
*/
const copyWelcome =
  'Selecciona la plantilla que mejor se ajuste a tus necesidades. Sigue las instrucciones para que tú mismo puedas generar y editar rápidamente nuestros documentos diseñados por abogados expertos'

const TemplateSelector = (): JSX.Element => {
  // const [template, setTemplate] = useState<ITemplate | undefined>()
  return (
    <>
      <UserAppBar />
      {/* {template ? (
        <TemplateEditor template={template} />
      ) : ( */}
      <TemplateListTypes copyWelcome={copyWelcome} />
      {/* )} */}
    </>
  )
}

export default TemplateSelector